'use strict';

// Export web by default. Other platforms have custom index.[platform].js files
module.exports = require('./dist/web/ReactXP.js');



// WEBPACK FOOTER //
// ./~/reactxp/index.js